import React, { useState, useEffect } from 'react';

export const COUNTRY_COORDS = {
  IN:   { label: 'India',              tz: 'Asia/Kolkata',        lat: 28.61, lon: 77.21, city: 'New Delhi' },
  US:   { label: 'USA (Eastern)',      tz: 'America/New_York',    lat: 40.71, lon: -74.01, city: 'New York' },
  US_W: { label: 'USA (Pacific)',      tz: 'America/Los_Angeles', lat: 34.05, lon: -118.24, city: 'Los Angeles' },
  GB:   { label: 'United Kingdom',     tz: 'Europe/London',       lat: 51.51, lon: -0.13, city: 'London' },
  AE:   { label: 'UAE',                tz: 'Asia/Dubai',          lat: 25.20, lon: 55.27, city: 'Dubai' },
  SG:   { label: 'Singapore',          tz: 'Asia/Singapore',      lat: 1.35,  lon: 103.82, city: 'Singapore' },
  AU:   { label: 'Australia (Sydney)', tz: 'Australia/Sydney',    lat: -33.87, lon: 151.21, city: 'Sydney' },
};

const WEATHER_ICONS = {
  0: '☀️', 1: '🌤️', 2: '⛅', 3: '☁️',
  45: '🌫️', 48: '🌫️',
  51: '🌦️', 53: '🌦️', 55: '🌦️',
  61: '🌧️', 63: '🌧️', 65: '🌧️',
  71: '🌨️', 73: '🌨️', 75: '🌨️',
  80: '🌦️', 81: '🌧️', 82: '⛈️',
  95: '⛈️', 96: '⛈️', 99: '⛈️',
};

export function getSelectedCountry() {
  return localStorage.getItem('nv_country') || 'IN';
}

export default function ClockWeather({ compact }) {
  const [country, setCountry] = useState(getSelectedCountry());
  const [now, setNow] = useState(new Date());
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onCountryChange = () => setCountry(getSelectedCountry());
    window.addEventListener('cu_country_changed', onCountryChange);
    window.addEventListener('storage', onCountryChange);
    return () => {
      window.removeEventListener('cu_country_changed', onCountryChange);
      window.removeEventListener('storage', onCountryChange);
    };
  }, []);

  useEffect(() => {
    const c = COUNTRY_COORDS[country] || COUNTRY_COORDS.IN;
    const fetchWeather = async () => {
      try {
        const res = await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${c.lat}&longitude=${c.lon}&current_weather=true`);
        const data = await res.json();
        setWeather(data.current_weather);
      } catch (e) { /* silent */ }
    };
    fetchWeather();
    const refresh = setInterval(fetchWeather, 15 * 60000);
    return () => clearInterval(refresh);
  }, [country]);

  const c = COUNTRY_COORDS[country] || COUNTRY_COORDS.IN;
  const timeStr = now.toLocaleTimeString('en-US', { timeZone: c.tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  const dateStr = now.toLocaleDateString('en-US', { timeZone: c.tz, weekday: 'short', month: 'short', day: 'numeric' });

  if (compact) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 15, fontWeight: 700, color: 'var(--text-primary)' }}>{timeStr}</div>
        <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{dateStr}</div>
        {weather && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: 'var(--text-secondary)', borderLeft: '1px solid var(--border)', paddingLeft: 10 }}>
            <span>{WEATHER_ICONS[weather.weathercode] || '🌡️'}</span>
            <span>{Math.round(weather.temperature)}°C</span>
            <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>{c.city}</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{
      padding: '10px 12px', margin: '0 8px 10px', borderRadius: 10,
      background: 'var(--bg-secondary)', border: '1px solid var(--border)',
    }}>
      <div style={{ fontFamily: 'var(--font-mono)', fontSize: 18, fontWeight: 700, color: 'var(--text-primary)', letterSpacing: '0.5px' }}>
        {timeStr}
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-secondary)', marginBottom: 8 }}>{dateStr}</div>
      {weather ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, borderTop: '1px solid var(--border)', paddingTop: 8 }}>
          <span style={{ fontSize: 20 }}>{WEATHER_ICONS[weather.weathercode] || '🌡️'}</span>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)' }}>{Math.round(weather.temperature)}°C</div>
            <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>{c.city} · {Math.round(weather.windspeed)} km/h wind</div>
          </div>
        </div>
      ) : (
        <div style={{ fontSize: 10, color: 'var(--text-muted)', borderTop: '1px solid var(--border)', paddingTop: 8 }}>Loading weather…</div>
      )}
    </div>
  );
}
